export default [
  {
    path: '/notice-index',
    component: () => import('@/views/notice/Index.vue'),
    name: 'notice.index',
    meta: {
      title: '收不到消息通知?',
      backgroundClass: 'bg-gray',
    },
    hidden: true,
  },
];
